import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72294090"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field--poland-tax-residence-field" }
const _hoisted_2 = { class: "field--poland-tax-residence-field__tax-office-information" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_TaxOfficeListField = _resolveComponent("TaxOfficeListField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.chooseTaxOffice`)), 1),
      _createVNode(_component_Field, {
        modelValue: _ctx.formData.polandTaxOfficeName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.formData.polandTaxOfficeName = $event)),
        type: "text",
        name: _ctx.name + 'PolandTaxOfficeName',
        placeholder: 
                    _ctx.$t(`${_ctx.TRANSLATION_KEY}.chooseTaxOfficePlaceholder`)
                ,
        readonly: true,
        "is-numeric": true,
        onFocus: _ctx.toggleTaxOfficesList
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.taxOffice`)), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "name", "placeholder", "onFocus"]),
      _createElementVNode("button", {
        type: "button",
        class: "field--poland-tax-residence-field__tax-offices-list",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleTaxOfficesList && _ctx.toggleTaxOfficesList(...args)))
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.showAllTaxOffices`)), 1)
      ])
    ]),
    _createVNode(_component_TaxOfficeListField, {
      "is-open": _ctx.isTaxOfficesListOpen,
      "tax-office-data-foreigner": _ctx.taxOfficeDataForeigner,
      name: _ctx.name + 'firstTaxOfficeList',
      "passed-data": _ctx.passedData,
      "tax-residence": "firstTaxResidence",
      onClose: _ctx.toggleTaxOfficesList,
      onOfficeSelected: _ctx.setTaxOffice
    }, null, 8, ["is-open", "tax-office-data-foreigner", "name", "passed-data", "onClose", "onOfficeSelected"]),
    (_ctx.isCitizenshipOtherThanPl)
      ? (_openBlock(), _createBlock(_component_Field, {
          key: "polandTaxResidentPesel",
          modelValue: _ctx.formData.polandTaxResidentPesel,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.polandTaxResidentPesel = $event)),
          type: "text",
          name: _ctx.name + 'PolandTaxResidentPesel',
          placeholder: _ctx.$t(`${_ctx.TRANSLATION_KEY}.polandTaxResidentPesel`),
          "cy-data": "polandTaxResidentPesel",
          "is-numeric": true
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.polandTaxResidentPesel`)), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "name", "placeholder"]))
      : _createCommentVNode("", true)
  ]))
}